import { EarlyAccessForm } from '@/features/early-access/components/EarlyAccessForm';
import type { ReactNode } from 'react';

/**
 * FinalCta — the public landing close. It now hosts the persisted early
 * access request form without changing the landing sequence.
 */
export function FinalCta(): ReactNode {
  return (
    <section className="relative overflow-hidden bg-surface-base py-24">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-secondary-fixed/5 blur-[100px]"
      />
      <div className="relative z-10 mx-auto max-w-container-max px-margin-mobile md:px-margin-desktop">
        <EarlyAccessForm />
      </div>
    </section>
  );
}

export default FinalCta;
